import styled from 'styled-components';

const pillRadius = ({ theme }) => theme?.radiusPill || '999px';
const segmentBorder = ({ theme }) =>
  theme?.dark
    ? `1.5px solid ${theme.borderSubtle || theme.inputBorder}`
    : `1.5px solid ${theme.inputBorder || '#D0D5DD'}`;
const filterTabBg = ({ theme }) =>
  theme?.dark ? theme.fieldLabelBg : theme.bodyBg;

const StyledFilterTabs = styled.div`
  button {
    padding: ${(props) => props.padding ?? '8px 14px'};
    background-color: ${filterTabBg};
    border: ${segmentBorder};
    border-radius: ${pillRadius};
    font-weight: ${({ theme }) => theme?.fontWeightMedium || 500};
    font-size: ${({ theme }) => theme?.fontSizeSm || '13px'};
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.actionsIconColor || theme.textSecondary};
    transition: all 0.15s ease;
    &:active,
    &.active {
      color: ${({ theme }) => theme.onHeader} !important;
      border: 1.5px solid
        ${({ theme }) =>
          theme?.dark
            ? theme.secondary || '#dc601e'
            : theme.headerBg || theme.sideBar || theme.primary};
      background-color: ${({ theme }) =>
        theme?.dark
          ? theme.secondary || '#dc601e'
          : theme.headerBg || theme.sideBar || theme.primary} !important;
      z-index: 1;
    }
    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.secondary || '#dc601e'};
      outline-offset: 2px;
      z-index: 2;
    }
    &:hover:not(.active) {
      border: 1.5px solid
        ${({ theme }) => theme.secondary || theme.secondaryLight};
      background-color: ${({ theme }) =>
        theme?.dark ? theme?.filterHoverBg : theme.secondaryLight2} !important;
      z-index: 1;
    }
    &.not-active {
      background-color: ${filterTabBg};
      border: ${segmentBorder};
      color: ${({ theme }) => theme.actionsIconColor || theme.textSecondary};
    }

    svg [stroke]:not([stroke='none']) {
      stroke: currentColor;
    }

    svg [fill]:not([fill='none']) {
      fill: currentColor;
    }
  }

  /* Attached segmented control — flush edges, shared outer pill */
  .btn-group {
    display: inline-flex;
    vertical-align: middle;

    > button,
    > .btn {
      border-radius: 0 !important;
      margin: 0;
      position: relative;

      &:not(:first-child) {
        margin-left: -1.5px;
      }

      &:first-child {
        border-top-left-radius: ${pillRadius} !important;
        border-bottom-left-radius: ${pillRadius} !important;
      }

      &:last-child {
        border-top-right-radius: ${pillRadius} !important;
        border-bottom-right-radius: ${pillRadius} !important;
      }
    }
  }
`;

export default StyledFilterTabs;
